import React from 'react';
import Modal from '../../../../../components/Modal';
import ExcelUploadForm from '../../../../../components/form/ExcelUploadForm';
import Anchor from '../../../../../components/link/Anchor';
import { DELIVERY_DISPATCH_UPLOAD_TEMPLATE_XLSX_URL } from '../../../../../constants/service/common/staticFileUrlConstants';
import './ExcelBulkDeliveryDispatchModal.scss';

const ExcelBulkDeliveryDispatchModal = (props) => {
  const { isOpen, file, onChange, onSubmit, closeModal } = props;

  return (
    <Modal
      title="송장 번호 일괄 등록"
      isOpen={isOpen}
      width={600}
      height={320}
      isFooter={true}
      okText="일괄 발송 처리"
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <div className="excel-bulk-delivery-dispatch-modal-wrap">
        <div className="excel-bulk-delivery-dispatch-title">
          <span className="guide">* 엑셀 파일을 업로드해주세요.</span>
          <Anchor
            className="template-download"
            text="일괄 발송 처리 양식 다운"
            isUnderLine={true}
            color="primary"
            href={DELIVERY_DISPATCH_UPLOAD_TEMPLATE_XLSX_URL}
            target="_blank"
          />
        </div>

        <div className="excel-file-finder-section">
          <span className="file-name">{file ? file.name : ''}</span>
          <ExcelUploadForm onChange={(file) => onChange(file)} />
        </div>

        <div className="excel-bulk-delivery-dispatch-info">
          <div>- 우측 상단의 샘플 다운로드를 클릭한 후, 파일을 저장 해주세요.</div>
          <div>
            - 주문이 들어온 건들에 대해 일괄로 배송처리를 하기 위해, 해당 양식에 맞추어 엑셀 파일을 작성 후 '찾아보기'
            를 클릭하여 엑셀 파일을 업로드 해주세요.
          </div>
          <div>
            - 배송 처리를 하려는 건수에 대해 미리 엑셀파일로 다운로드 한 뒤, 숫자와 텍스트를 정확히 입력해주세요.
          </div>
          <div>- 5행부터 8행까지의 예시를 참고해서 작업해주세요.</div>
          <div className="emphasize">- 업로드하실 때는, 1행을 제외한 모든 행을 삭제하고 등록을 시작 해주세요.</div>
        </div>
      </div>
    </Modal>
  );
};

export default ExcelBulkDeliveryDispatchModal;
